import "./styles.scss";

import { Text } from "@amzn/stencil-react-components/text";
import React, { FC, useState } from "react";

export interface ReviewFieldProps {
  label: string;
  value: string | React.ReactNode;
  "data-cy"?: string;
  maxLength?: number; // prop to enable truncation for long string fields
}

export const ReviewField: FC<ReviewFieldProps> = ({ label, value, "data-cy": dataCy, maxLength }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const renderValue = () => {
    if (typeof value !== "string") {
      return value;
    }

    if (!maxLength || value.length <= maxLength) {
      return <Text fontSize="T150">{value}</Text>;
    }

    // For long strings, truncate with see more link to show entirety
    const truncatedValue = value.substring(0, maxLength);

    return (
      <Text fontSize="T150">
        {isExpanded ? value : `${truncatedValue}...`}{" "}
        <button
          type="button"
          onClick={() => setIsExpanded(!isExpanded)}
          className="review-field-toggle"
          data-cy={`${dataCy}-toggle`}
        >
          {isExpanded ? "show less" : "show more"}
        </button>
      </Text>
    );
  };

  return (
    <div className="review-field" data-cy={dataCy}>
      <Text fontSize="T150" fontWeight="bold" className="review-field-label">
        {label}
      </Text>
      <div className="review-field-content">{renderValue()}</div>
    </div>
  );
};
